module.exports = __webpack_public_path__ + "static/media/KAPorg-blue.c02b2cba.svg";